import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import Popup from "reactjs-popup";
import ColorSet from "./ColorSet";
import ImageMarkersStudio from "./ImageMarkersStudio";
import SaveAnimation from "./otherResources/SaveAnimation";
import {
    setColor,
    changeLevel,
    nextStep,
    setColorBackground,
    setOpenImageMarkers,
    setColorText,
    changeCamKey,
    ifloorplanStateAdd,
    setVideosSidebar,
    changeImageKey,
    changeCamPosition,
    panelumLib,
    set360ToolsAction,
    changePannellumKey,
} from "../redux/actions/actions";
import { updateNewPlan, createNewPlan, getCurrentUser } from "../serverRequests/requests";
import { useRouter } from 'next/router';
import { getIfloorplan } from "../../Ifloorplan/serverRequests/requests";
import PublishModal from "./modals/PublishModal";
import UpdatedModal from "./modals/UpdatedModal";
import AfterPublishModal from "./modals/AfterPublishModal";
import WarningModal from "./modals/AddImageWarningModal";
import ViewMobileWarningModal from "./modals/ViewMobileWarningModal";

const TopPanel = (props) => {
    const router = useRouter();
    const [shareUrl, setShareUrl] = useState((props.current_user.domain_api ? props.current_user.domain_api :
        (window.location.href.replace(router.asPath, '') + "/ifloorplan/")) + props.ifloorplanNowState.id);
    const [showMenu, setShowMenu] = useState("none"); //Main menu tools enable/disable
    const [newLevelName, setNewLevelName] = useState(""); //New Level name
    const [addLevelPopup, setAddLevelPopup] = useState(false); //add level popup enable/disable
    const [saveAsTemplatePopup, setSaveAsTemplatePopup] = useState(false); //save as template popup enable/disable
    const [newTemplateName, setNewTemplateName] = useState(""); //new template name

    const [nowLevelName, setNowLevelName] = useState("");

    const [nextBtnColor, setNextBtnColor] = useState("orange");
    const [prevBtnColor, setPrevBtnColor] = useState("blue");

    const allowTopBar = props.step === "cams position" || (props.step === "scale layout" &&
        (props.ifloorplanNowState.level[props.levelNowId].images.length > 0 || props.ifloorplanNowState.level[props.levelNowId].panelum.length > 0))
    const ifloorplanObj = props.ifloorplanNowState; //last ifloor plan obj
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [showPublishedModal, setshowPublishedModal] = useState(false);
    const [afterPublishModal, setAfterPublishModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [showShareIcons, setShowShareIcons] = useState(false);
    const [copiedLink, setCopiedLink] = useState(false);
    const [haveCredits, setHaveCredits] = useState(true);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showViewMobileWarningModal, setShowViewMobileWarningModal] = useState(false);

    const handleClickTools = () => {
        // enable/disable main menu tools toggle function
        if (showMenu === "none") {
            setShowMenu("block");
        } else {
            setShowMenu("none");
        }
    };

    useEffect(() => {
        setNowLevelName(
            props.ifloorplanNowState.level[props.levelNowId].tabLabel
        );
        document.addEventListener('click', (e) => {
            if (!e.target.className.includes('PublishModal') && !e.target.className.includes('UpdateModal') && e.target.id !== 'PublishModalBtn')
                setShowPublishModal(false);
            if (!e.target.className.includes('UpdatedModal') && !e.target.className.includes('PublishModal') && !e.target.className.includes('UpdateModal'))
                setshowPublishedModal(false);
            if (!e.target.className.includes('AfterPublishModal') && !e.target.className.includes('PublishModal') && !e.target.className.includes('UpdateModal'))
                setAfterPublishModal(false);
            if (!e.target.className.includes('WarningModal') && !e.target.className.includes('UpdateModal') && e.target.id !== 'PublishModalBtn' && !e.target.className.includes('previewBtn'))
                setShowWarningModal(false);
            if (!e.target.className.includes('WarningModal') && !e.target.className.includes('UpdateModal') && e.target.id !== 'PublishModalBtn')
                setShowViewMobileWarningModal(false);
        })

        getCurrentUser().then(res => {
            if (res.credits === 0) {
                setHaveCredits(false);
            }
        })
    }, []);

    useEffect(() => {
        setNowLevelName(
            props.ifloorplanNowState.level[props.levelNowId].tabLabel
        );
    }, [props.levelNowId, props.ifloorplanNowState]);

    const handleClickItem = (stepName, key = "_") => {
        handleClickTools(); //close main menu tools
        if (props.prev_step == "cams position")
            window.removeEventListener('resize', handleResizeScreen);
        props.nextStep(stepName, key); //next step
    };


    const handleNext = (e) => {
        //next image to set position cam
        e.preventDefault();
        const images = props.ifloorplanNowState.level[props.levelNowId].images; //all images current level
        const panellums = props.ifloorplanNowState.level[props.levelNowId].panelum;
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState)); //main object floor plan
        if (props.image_markers_layout) {
            //if open image markers dont send data to server
            if (props.image_key !== images.length - 1) {
                //if now index image last when not upper index
                props.changeImageKey(props.image_key + 1); //up index
            } else {
                setNextBtnColor("blue");
            }
            let form_data = new FormData();
            form_data.append('id', ifloorplanObj.id);
        } else {

            if ((props.image_key == -1 && props.pannellum_key == -1)) {
                return;
            }
            else if (props.image_key < images.length - 1 && props.image_key >= 0) {
                //if now index image last when not upper index
                props.changeImageKey(props.image_key + 1); //up index
                props.changePannellumKey(-1);
            }
            else if (props.pannellum_key === -1 && panellums.length > 0) {
                props.changePannellumKey(0);
                props.changeImageKey(-1);
            }
            else if (props.pannellum_key < panellums.length - 1) {
                props.changePannellumKey(props.pannellum_key + 1);
                props.changeImageKey(-1);
            }
            updateNewPlan(newState).then((data) => {
                props.setAnimation((animationSaved) => animationSaved + 1);
                props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                props.changeCamPosition(data[0]); //update second state ifloorplan
            });
        }
    };

    const handlePrev = (e) => {
        //previos index image to set position cam
        e.preventDefault();
        const images = props.ifloorplanNowState.level[props.levelNowId].images; //all images current level
        const panellums = props.ifloorplanNowState.level[props.levelNowId].panelum;
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        setNextBtnColor("orange");
        if (props.step === "cams position") {
            if (props.pannellum_key == -1 && props.image_key == -1) {
                if (panellums.length > 0) {
                    props.changePannellumKey(panellums.length - 1);
                    props.changeImageKey(-1);
                }
                else if (images.length > 0) {
                    props.changeImageKey(images.length - 1);
                    props.changePannellumKey(-1);
                }
            }
            else if (props.pannellum_key > 0) {
                props.changePannellumKey(props.pannellum_key - 1);
                props.changeImageKey(-1);
            }
            else if (props.image_key === -1 && images.length > 0) {
                props.changeImageKey(images.length - 1);
                props.changePannellumKey(-1);
            }
            else if (props.image_key > 0) {
                props.changeImageKey(props.image_key - 1); //lower index
                props.changePannellumKey(-1);
            }
        }
        else if (props.step === "scale layout") {
            if (panellums.length > 0) {
                props.changePannellumKey(panellums.length - 1);
                props.changeImageKey(-1);
            }
            else if (images.length > 0) {
                props.changeImageKey(images.length - 1);
                props.changePannellumKey(-1);
            }
            props.nextStep("cams position");
        }
        updateNewPlan(newState).then((data) => {
            props.setAnimation((animationSaved) => animationSaved + 1);
            props.ifloorplanStateAdd(data[0]); //update state ifloorplan
            props.changeCamPosition(data[0]);
        })
    };

    useEffect(() => {
        const images = props.ifloorplanNowState.level[props.levelNowId].images; //all images current level
        const panellums = props.ifloorplanNowState.level[props.levelNowId].panelum;
        if ((props.image_key == 0) || (props.pannellum_key == 0 && images.length == 0)) {
            setPrevBtnColor("gray");
        }
        else setPrevBtnColor("blue");
        if ((props.image_key == images.length - 1 && panellums.length == 0) ||
            (props.pannellum_key == panellums.length - 1 && panellums.length > 0))
            setNextBtnColor("gray");
        else setNextBtnColor("orange");
    }, [props.image_key, props.pannellum_key])

    const newLevel = () => {
        //new level create function
        const newLevelObj = {
            //new object level
            tabLabel: newLevelName,
            index: ifloorplanObj.level.length, //set last index
            //set default values as of first level
            plan_pos_x: ifloorplanObj.level[0].plan_pos_x,
            plan_pos_y: ifloorplanObj.level[0].plan_pos_y,
            plan_width: ifloorplanObj.level[0].plan_width,
            portrait_plan_pos_x: ifloorplanObj.level[0].portrait_plan_pos_x,
            portrait_plan_pos_y: ifloorplanObj.level[0].portrait_plan_pos_y,
            portrait_plan_width: ifloorplanObj.level[0].portrait_plan_width,
            landscape_plan_pos_x: ifloorplanObj.level[0].landscape_plan_pos_x,
            landscape_plan_pos_y: ifloorplanObj.level[0].landscape_plan_pos_y,
            landscape_plan_width: ifloorplanObj.level[0].landscape_plan_width,
            custom_portrait: ifloorplanObj.level[0].custom_portrait,
            custom_landscape: ifloorplanObj.level[0].custom_landscape
        };
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState)); //prev obj ifloorplan
        newState.level.push(newLevelObj); //add new level to array
        newState.viewed_mobile_editor = false;
        setAddLevelPopup(false); //disable level popup
        handleClickTools(); //disable main menu tools
        updateNewPlan(newState).then((data) => {
            let newState = JSON.parse(JSON.stringify(data[0]));
            newState.level[data[0].level.length - 1].plan_level.push({
                img: null,
            });
            updateNewPlan(newState).then((data) => {
                props.setAnimation((animationSaved) => animationSaved + 1);
                props.changeImageKey(-1);
                props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                props.changeCamPosition(data[0]); //update second ifloorplan objecct
                props.nextStep("plan library", "new level"); //next step
                props.changeLevel(data[0].level.length - 1); //set new index level to edit
            })
        });
    };

    const newPanelum = () => {
        //new panorama
        handleClickItem("360 library"); //next step

    };

    const newTemplate = () => {
        let newState = JSON.parse(JSON.stringify(ifloorplanObj));
        newState.template_name = newTemplateName;
        newState.address = "";
        newState.viewed = 0;

        for (let i = 0; ifloorplanObj.level.length > i; i++) {
            newState.level[i].images = [];
            delete newState.level[i].id;
            delete newState.level[i].plan;
            delete newState.level[i].panelum;
            newState.level[i].plan_level = {
                img: null,
            };
            delete newState.level[i].video_marker;
        }
        delete newState.id;
        delete newState.author;
        delete newState.media;
        delete newState.order;
        newState.published = false;
        newState.first_published_datetime = false;
        newState.paid = false;
        newState.start_live = (new Date()).getTime() / 1000;
        createNewPlan(newState).then((data_res) => {
            return 1;
        });
        setSaveAsTemplatePopup(false);
    };

    const Publish = () => {
        //publish function
        let newState = JSON.parse(JSON.stringify(ifloorplanObj)); //last state ifloorplan
        if (props.type_action === "new" || !newState.first_published_datetime) {
            //if create new plan but not edit
            newState.end_live = parseInt(new Date().getTime() / 1000 + 365 * 24 * 3600); //add time delay to delete
        }
        newState.published = true; //set active status publish
        updateNewPlan(newState).then((data) => {
            if (data) {
                props.setAnimation((animationSaved) => animationSaved + 1);
                setshowPublishedModal(true);
                setShowShareIcons(false);
                setCopiedLink(false);
                props.ifloorplanStateAdd(data[0]); //update state ifloorplan
                props.changeCamPosition(data[0]);  //update second state ifloorplan
                if (props.type_action === "edit") {
                    //if edit - not change step
                    return 1;
                }
            }
        });
    };

    useEffect(() => {
        const delay = setTimeout(() => {
            try {
                let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
                updateNewPlan(newState)
            } catch (error) {
                console.log('🚀 | file: TopPanel.js | line 323 | error', error);
            }
        }, 500);
        return () => clearTimeout(delay);
    }, [props.ifloorplanNowState])

    const warningLevel = [];

    const isZeroMediaWarningVisible = !props.ifloorplanNowState.level.every(level => level.images?.length || level.panelum?.length)

    props.ifloorplanNowState.level.map(level => {
        if (!(level.images?.length || level.panelum?.length))
            warningLevel.push({ level: level.tabLabel, media: 'images' });
    })

    const isPublishable = props.ifloorplanNowState.level.some(level => level.images?.length || level.panelum?.length);
    const saveViewedMobileEditor = () => {
        let newState = JSON.parse(JSON.stringify(props.ifloorplanNowState));
        newState.viewed_mobile_editor = true;
        props.ifloorplanStateAdd(newState);
    }

    return (
        <div className="topPanelWrap">
            <div className="firstOpt">
                <i className="fa fa-caret-up" aria-hidden="true"></i>
                <div
                    className="toolsBtn"
                    style={{ backgroundColor: "#1276EB" }}
                >
                    <div
                        className="toolsBtnWrapp"
                        onClick={
                            handleClickTools //open the Tools (changed by Liza)
                        }
                    >
                        <p>Tools</p>

                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                    </div>
                    <div className="MenuWrap" style={{ display: showMenu }}>
                        <div
                            className="itemMenu"
                            onClick={() =>
                                handleClickItem("plan library")
                            }
                        >
                            <p>Floor plan Library</p>
                        </div>
                        {/* <div className="itemMenu SubMenuWrap">
                            <p>Floor Plan</p>
                            <i
                                className="fa fa-caret-right"
                                aria-hidden="true"
                            ></i>
                            <div className="SubItems">
                                <div className="itemMenu"
                                onClick={() =>
                                        handleClickItem("plan library")
                                    }
                                >
                                    <p>Floor plan Library</p>
                                </div>

                                <div className="itemMenu"
                                onClick={() => handleClickItem("scale and repos", "scale plan")}>
                                    <p>Scale and Reposition</p>
                                </div>
                            </div>
                        </div> */}
                        <div
                            className="itemMenu"
                            onClick={() =>
                                handleClickItem("image library")
                            }
                        >
                            <p>Image Library</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickTools(); //close menu
                                newPanelum(); //new panorama object
                            }}
                        >
                            <p>360 Image Library</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => handleClickItem("clients")}
                        >
                            <p>Client Library</p>
                        </div>
                        <div
                            className="itemMenu"
                            style={{ position: "relative" }}
                            onClick={() => setAddLevelPopup(true)}
                        >
                            <p>Add Levels</p>
                        </div>
                        <div
                            className="addLevelWrap"
                            style={{
                                display: addLevelPopup ? "block" : "none",
                            }}
                        >
                            <h3>Add new level</h3>
                            <p>Write a name for this level</p>
                            <input
                                onChange={(e) => {
                                    setNewLevelName(e.target.value);
                                }}
                                type="text"
                            />
                            <p>This name appears on the navigation tab</p>
                            <div className="btnGroup">
                                <button onClick={() => setAddLevelPopup(false)}>
                                    Cancel
                                </button>
                                <button onClick={newLevel}>Add level</button>
                            </div>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickTools(); //close menu
                                handleClickItem("manage levels");
                            }}
                        >
                            <p>Manage Levels</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickTools(); //close menu
                                handleClickItem("add media");
                            }}
                        >
                            <p>Add external media</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickItem("cams position");
                                props.setOpenImageMarkers(true);
                            }}
                        >
                            <p>Image Markers</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickTools(); //close menu
                                handleClickItem("cams position");
                                props.setColor(true); //open menu set color
                            }}
                        >
                            <p>Background Colour</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => handleClickItem("text editor")}
                        >
                            <p>Add Text Information</p>
                        </div>
                        <div
                            className="itemMenu"
                            onClick={() => {
                                setSaveAsTemplatePopup(true);
                            }}
                        >
                            <p>Save as Template</p>
                        </div>
                        <div
                            className="saveAsTemplateWrap"
                            style={{
                                display: saveAsTemplatePopup ? "block" : "none",
                            }}
                        >
                            <h3>Save as a Template</h3>
                            <p>Write a name for your Template</p>
                            <input
                                onChange={(e) => {
                                    setNewTemplateName(e.target.value);
                                }}
                                type="text"
                                placeholder=""
                            />
                            <p>You can edit this name in the Templates tab</p>
                            <div className="btnGroup">
                                <button
                                    onClick={() =>
                                        setSaveAsTemplatePopup(false)
                                    }
                                >
                                    Cancel
                                </button>
                                <button onClick={newTemplate}>Save</button>
                            </div>
                        </div>
                        {/* <div
                            className="itemMenu"
                            onClick={() => {
                                handleClickTools(); //close menu
                                handleClickItem("add lat and long");
                            }}
                        >
                            <p>Add Lat and Long</p>
                        </div> */}
                    </div>
                </div>
                {/*=====================================*/}

                <div className="secondOpt">
                    {props.type_action === 'new' ? 'Creating New.' : 'Editing: ' + nowLevelName}
                </div>
                {/*    =======================================*/}
            </div>
            {[
                "upload plans",
                "upload images",
                "360 library upload",
                "upload files",
            ].includes(props.step) ? (
                ""
            ) : (
                <div className="secondOptBtn">
                    {/*======btn preev next ============*/}
                    <div
                        onClick={(event) => {
                            event.preventDefault();
                            if (
                                props.step === "cams position" ||
                                props.step === "panorama" ||
                                props.step === "scale layout"
                            ) {
                                handlePrev(event);
                            }
                        }}
                        className={
                            props.step === "cams position" ||
                                props.step === "panorama" ||
                                props.step === "scale layout"
                                ? "prevBtn"
                                : "prevBtn not"
                        }
                        style={{ color: prevBtnColor }}
                    >
                        <i className="fa fa-caret-left" aria-hidden="true"></i>
                        <p style={{ color: prevBtnColor }}>Previous</p>
                    </div>

                    <div
                        onClick={(event) => {
                            event.preventDefault();
                            if (
                                props.step === "cams position" ||
                                props.step === "panorama"
                            ) {
                                handleNext(event);
                            }
                        }}
                        className={
                            props.step === "cams position" ||
                                props.step === "panorama"
                                ? "nextBtn"
                                : "nextBtn not"
                        }
                        style={{ color: nextBtnColor }}
                    >
                        <p style={{ color: nextBtnColor }}>
                            Next
                        </p>
                        <i className="fa fa-caret-right" aria-hidden="true"></i>
                    </div>
                    <div className={allowTopBar || props.step === "portrait scale layout"
                        || props.step === "landscape scale layout" ? "desktopLayout" : "desktopLayout not"}
                        onClick={() => {
                            if (allowTopBar || props.step === "portrait scale layout"
                                || props.step === "landscape scale layout")
                                props.nextStep("cams position", '_');
                        }}>
                        <i className="fas fa-desktop"></i>
                    </div>
                    <div className={allowTopBar || props.step === "portrait scale layout"
                        || props.step === "landscape scale layout" ? "portraitLayout" : "portraitLayout not"}
                        onClick={() => {
                            if (allowTopBar || props.step === "portrait scale layout"
                                || props.step === "landscape scale layout"){
                                saveViewedMobileEditor();
                                props.nextStep("portrait scale layout", '_');
                            }
                        }}>
                        <i className="fas fa-mobile-alt"></i>
                    </div>
                    <div className={allowTopBar || props.step === "portrait scale layout"
                        || props.step === "landscape scale layout" ? "landscapeLayout" : "landscapeLayout not"}
                        onClick={() => {
                            if (allowTopBar || props.step === "portrait scale layout"
                                || props.step === "landscape scale layout"){
                                saveViewedMobileEditor();
                                props.nextStep("landscape scale layout", '_');
                            }
                        }}>
                        <i className="fas fa-mobile-alt" style={{ transform: "rotate(90deg)" }}></i>
                    </div>


                </div>
            )}

            <div className="thirthOpt">
                <SaveAnimation
                    animation={props.animation}
                    state={props.ifloorplanNowState}
                />
                <a
                    href=""
                    className={
                        props.step === "cams position" ||
                            props.step === "panorama"
                            ? "saveNowBtn"
                            : "saveNowBtn not"
                    }
                    onClick={(event) => {
                        event.preventDefault();
                        if (props.step === "cams position") {
                        }
                    }}
                >
                    {/*<p>Save now...</p>*/}
                </a>
                <a href={'/ifloorplan/' + ifloorplanObj.id + '/preview'}
                    onClick={(event) => {
                        if (props.LibraryImage.length === 0) {
                            event.preventDefault();
                            setPreviewUrl('/ifloorplan/' + ifloorplanObj.id + '/preview');
                            setShowWarningModal(true);
                        }
                        if (!allowTopBar) {
                            event.preventDefault();
                        }
                    }}
                    target="_blank"
                    className={allowTopBar ? "previewBtn" : "previewBtn not"}>
                    Preview
                </a>
                <a href="" id='PublishModalBtn' className={allowTopBar ? "publishBtn" : "publishBtn not"}
                    style={{
                        backgroundColor: props.ifloorplanNowState.published ? '#ffffff' : '',
                        color: props.ifloorplanNowState.published ? '#000' : '', cursor: 'default'
                    }}
                    onMouseOver={() => {
                        if (props.ifloorplanNowState.published)
                            setAfterPublishModal(true);
                    }}

                    onClick={async (event) => {
                        event.preventDefault();
                        if (props.LibraryImage.length === 0) {
                            setPreviewUrl(null);
                            setShowWarningModal(true);
                        }
                        else if (!props.ifloorplanNowState.viewed_mobile_editor) {
                            setShowViewMobileWarningModal(true);
                        }
                        else if (props.ifloorplanNowState.id) {
                            getIfloorplan(props.ifloorplanNowState.id)
                                .then((res) => {
                                    props.ifloorplanStateAdd(res[0]);
                                    if (!res[0]?.published) {
                                        if (allowTopBar)
                                            setShowPublishModal(allowTopBar && (!showPublishModal) && (!showPublishedModal));
                                        setshowPublishedModal(false);
                                        setShowViewMobileWarningModal(false);
                                    }
                                },
                                    (error) => {
                                        setError(true);
                                    }
                                )
                        }
                    }}
                >
                    {props.ifloorplanNowState.first_published_datetime ? !props.ifloorplanNowState.published ? "Republish" : "Published" : "Publish..."}

                </a>
                <PublishModal
                    showPublishModal={showPublishModal}
                    setShowPublishModal={setShowPublishModal}
                    isPublishable={isPublishable}
                    isZeroMediaWarningVisible={isZeroMediaWarningVisible}
                    warningLevel={warningLevel}
                    Publish={Publish}
                    haveCredits={haveCredits}
                    allowTopBar={allowTopBar}
                />
            </div>
            <WarningModal 
                showWarningModal={showWarningModal}
                setShowWarningModal={setShowWarningModal}
                handleClickItem={handleClickItem}
                previewUrl={previewUrl}
            />
            <UpdatedModal
                showPublishedModal={showPublishedModal}
                shareUrl={shareUrl}
                setCopiedLink={setCopiedLink}
                copiedLink={copiedLink}
                setShowShareIcons={setShowShareIcons}
                showShareIcons={showShareIcons}
            />
            <AfterPublishModal 
                afterPublishModal={afterPublishModal}
                setAfterPublishModal={setAfterPublishModal}
            />
            <ViewMobileWarningModal 
                showViewMobileWarningModal={showViewMobileWarningModal}
                setShowViewMobileWarningModal={setShowViewMobileWarningModal}
                save={saveViewedMobileEditor}
            />

            {props.set_color ? <ColorSet /> : ""}
            {props.image_markers_layout ? (
                <ImageMarkersStudio setAnimation={props.setAnimation} />
            ) : (
                ""
            )}
        </div>
    );
};

const putState = (state) => {
    return {
        step: state.step,
        positionCams: state.positionCams,
        ifloorplanNowState: state.ifloorplanNowState,
        levelNowId: state.levelNowId,
        image_key: state.image_key,
        cam_key: state.cam_key,
        set_color: state.set_color,
        prev_step: state.prev_step,
        type_action: state.type_action,
        image_markers_layout: state.image_markers_layout,
        pannellum_key: state.pannellum_key,
        current_user: state.current_user,
        LibraryImage: state.LibraryImage,
    };
};
const putActions = (dispatch) => {
    return {
        nextStep: (step, prevStep) => dispatch(nextStep(step, prevStep)),
        changeCamKey: (key) => dispatch(changeCamKey(key)),
        ifloorplanStateAdd: (plan) => dispatch(ifloorplanStateAdd(plan)),
        changeCamPosition: (obj) => dispatch(changeCamPosition(obj)),
        changeLevel: (level) => dispatch(changeLevel(level)),
        changeImageKey: (key) => dispatch(changeImageKey(key)),
        panelumLib: (items) => dispatch(panelumLib(items)),
        setColor: (bool) => dispatch(setColor(bool)),
        setColorBackground: (color) => dispatch(setColorBackground(color)),
        setColorText: (color) => dispatch(setColorText(color)),
        setOpenImageMarkers: (bool) => dispatch(setOpenImageMarkers(bool)),
        set360ToolsAction: (value) => dispatch(set360ToolsAction(value)),
        changePannellumKey: (key) => dispatch(changePannellumKey(key)),
    };
};

export default connect(putState, putActions)(TopPanel);
